import { render, staticRenderFns } from "./RecommendTeacher.vue?vue&type=template&id=2da41830&"
import script from "./RecommendTeacher.vue?vue&type=script&lang=js&"
export * from "./RecommendTeacher.vue?vue&type=script&lang=js&"
import style0 from "./RecommendTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports